import REST from 'go/requests/rest';
import _ from 'lodash';

export const getTaskIdForEntity = (
  token,
  permissions,
  entityId,
  taskDefinitionKey,
  retries
) => {
  let getWorkflowTasksBody = {};

  if (retries === undefined) retries = 0;

  if (!_.isEmpty(permissions)) {
    getWorkflowTasksBody.candidateGroups = permissions;
  }
  _.assign(getWorkflowTasksBody, {
    includeAssignedTasks: true,
    processVariables: [
      {
        name: 'entityId',
        value: entityId,
        operator: 'eq',
      },
    ],
    taskDefinitionKey,
  });

  return REST.workflow
    .getAllExternalEligibleTasks(token, '', getWorkflowTasksBody)
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      }
    })
    .then((resJson) => {
      if (resJson[0]) {
        return resJson[0].id;
      } else {
        if (retries > 0) {
          return getTaskIdForEntity(
            token,
            permissions,
            entityId,
            taskDefinitionKey,
            --retries
          );
        } else {
          return err;
        }
      }
    })
    .catch((err) => {
      console.log('Error getting tasks:');
    });
};

export const isSubApplicationConfig = (configType) => {
  const subApplicationConfigs = [
    'subgrantsummary',
    'subcomments',
    'subattachments',
    'subattachments_external',
    'subapplication',
    'subawardrecommendation',
    'subgrant',
  ];
  let isSubApplicationConfig = false;
  if (_.includes(subApplicationConfigs, _.toLower(configType))) {
    isSubApplicationConfig = true;
  }
  return isSubApplicationConfig;
};
